module.exports = __webpack_public_path__ + "img/backward.b5d6b84a.svg";